import { SituacaoFatura } from '../../../../../../_metronic/helpers'
import { StatusDot, StatusDotTone } from '../../../../../components'

const situacaoTone: Record<SituacaoFatura, StatusDotTone> = {
  [SituacaoFatura.Gerada]: 'warning',
  [SituacaoFatura.Autorizada]: 'primary',
  [SituacaoFatura.Paga]: 'success',
  [SituacaoFatura.Cancelada]: 'danger',
}

/** "GERADA" → "Gerada". */
export const situacaoFaturaLabel = (situacao?: SituacaoFatura) =>
  situacao ? situacao.charAt(0) + situacao.slice(1).toLowerCase() : undefined

/** Situação da fatura: rótulo + ponto colorido (cor nunca é o único portador de significado). */
export const SituacaoFaturaBadge = ({ situacao }: { situacao?: SituacaoFatura }) => (
  <StatusDot
    label={situacaoFaturaLabel(situacao)}
    tone={situacao ? situacaoTone[situacao] : undefined}
  />
)
